import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'

export const fetchCargoPackageById = createAsyncThunk(
  'FETCH_CARGO_BY_ID',
  async ({ cargoId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend}/api/cargo/${cargoId}`)

      return response.data
    } catch (error) {
      console.error('Error in FETCH_CARGO_BY_ID', error)
      return rejectWithValue(error)
    }
  }
)

export const putCargoById = createAsyncThunk(
  'PUT_CARGO_BY_ID',
  async ({ cargoId, body, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${backend}/api/cargo/${cargoId}`, body)
      enqueueSnackbar('Грузы были успешно обновлены', {
        variant: 'success',
      })
      return response?.data
    } catch (error) {
      enqueueSnackbar('Что-то пошло не так', {
        variant: 'error',
      })
      return rejectWithValue(error)
    }
  }
)
